export const SOURCES_HEADING = 'Sources';

export const SOURCES_HIDE_DELAY_MS = 500;

export const SOURCE_ROW_LOGO_SIZE = 20;

export const AGGREGATOR_HOSTS: readonly string[] = ['vertexaisearch.cloud.google.com'];
